import { Box, styled } from "@material-ui/core";
import { memo } from "react";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_SELECTED_BG,
  EPOCUS_STATUS_PENDING_BG,
  EPOCUS_STATUS_PENDING_TEXT,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../../_lib/epocus-palette";
import { Icon } from "./icons";

const Card = styled(Box)({
  backgroundColor: EPOCUS_WHITE,
  border: `1px solid ${EPOCUS_BORDER}`,
  borderRadius: 12,
  overflow: "hidden",
  margin: "2px 0 4px",
});

const Header = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontSize: rem(10.5),
  fontWeight: 600,
  color: EPOCUS_STATUS_PENDING_TEXT,
  backgroundColor: EPOCUS_STATUS_PENDING_BG,
  padding: "7px 13px",
  borderBottom: `1px solid ${EPOCUS_BORDER}`,
});

const Row = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "10px 13px",
  borderTop: `1px solid ${EPOCUS_BORDER}`,
  "&:first-child": { borderTop: "none" },
});

const Label = styled("span")({
  fontSize: rem(10.5),
  color: EPOCUS_TEXT_SECONDARY,
  minWidth: 52,
});

const Value = styled("span")({ fontSize: rem(13), fontWeight: 500 });

const Pill = styled("span")({
  marginLeft: "auto",
  fontSize: rem(10),
  color: EPOCUS_PRIMARY,
  backgroundColor: EPOCUS_SELECTED_BG,
  border: `1px solid ${EPOCUS_BORDER}`,
  borderRadius: 999,
  padding: "2px 8px",
  whiteSpace: "nowrap",
});

export const SummaryCard = memo<{
  title: string;
  rows: { label: string; value: string; pill?: string }[];
}>(({ title, rows }) => (
  <Card>
    <Header>
      <Icon name="crm" size={12} />
      {title}
    </Header>
    {rows.map((row) => (
      <Row key={row.label}>
        <Label>{row.label}</Label>
        <Value>{row.value}</Value>
        {row.pill && <Pill>{row.pill}</Pill>}
      </Row>
    ))}
  </Card>
));
SummaryCard.displayName = "SummaryCard";
